module.exports = __webpack_public_path__ + "static/media/pianostudisvg.9926c4c8.svg";